import styled from "styled-components"
export const Landing = styled.div`
  flex-direction: column;
  justify-content: space-evenly;

  .connect-map {
    /*  border: 1px solid var(--blue);
    padding: 5px 2px; 
    border-radius: 4px;*/
    @media (max-width: 1024px) {
      /* M */
      display: none;
    }
  }
  .data-privacy {
    display: flex;
    width: 50%;
    float: right;
    justify-content: flex-end;
    a {
      text-decoration: none;
      color: var(--grey);
    }

    @media (min-width: 1440px) {
      padding: 0 80px;
    }

    @media (max-width: 1024px) {
      width: 100%;
      padding-bottom: 40px;
    }
  }

  @media (max-width: 600px) {
    /* S */
    .main-container {
      flex-direction: column;
      justify-content: center;
      margin: 0 !important;

      .box {
        padding: 0 !important;
      }
    }

    .box:first-child {
      margin-top: 56px;
      margin-bottom: 80px;
    }

    .form {
      div {
        display: flex;
        flex-direction: column !important;
      }
    }
    .contact-info-container {
      display: flex;
      flex-direction: column;
      margin-bottom: 8px !important;
      img {
        padding-right: 8px !important;
      }
    }

    .button-container {
      flex-direction: column;
      align-items: flex-start !important;
      button {
        margin-bottom: 8px;
      }
      p {
        margin-bottom: 40px;
      }
    }
  }

  @media (min-width: 600px) and (max-width: 1023px) {
    /* M */

    .headline {
      margin-bottom: 40px !important;
    }
    .contact-info-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin-bottom: 8px !important;
      img {
        padding-right: 8px !important;
      }
    }
    .main-container {
      flex-direction: column;
      justify-content: center;
      margin: 0 !important;

      .box {
        padding: 0 !important;
      }
    }

    .box:first-child {
      margin-bottom: 104px;
    }
  }

  @media (min-width: 1024px) and (max-width: 1439px) {
    /* L */
    .main-container {
      margin: 0 !important;

      .box {
        padding: 0 !important;
      }
    }
  }
  min-height: 100vh;
  background: var(--beige);
  color: var(--grey);
  align-items: center;
  display: flex;

  .main-container {
    justify-content: space-between;

    .title {
      margin-bottom: 4px;
    }
    .headline {
      margin-bottom: 56px;
    }

    .box:first-child {
      padding: 0 70px 0 0;
      width: 100%;
    }

    .box:nth-child(2) {
      padding: 0 0 0 70px;
    }
    .box {
      width: 100%;
    }

    display: flex;
    margin: 0 80px;
  }
  .contact-info {
    align-items: center;
    display: flex;
    margin-bottom: 4px;
    img {
      height: 100%;
      padding-right: 16px;
    }
  }

  .form {
    .input-container:first-child {
      margin-right: 24px;
    }
    .input-container {
      width: 100%;
      margin-bottom: 24px;

      .input-header {
        margin-bottom: 4px;
      }

      .form-input {
        padding-bottom: 2px;
        background: transparent;
        border: none;
        border-bottom: 1px solid var(--grey);

        color: var(--grey);
        width: 100%;
        ::placeholder {
          opacity: 0.6;
          color: var(--grey);
        }
        :focus {
          outline: none;
        }
      }

      .missing {
        border-bottom: 1px solid var(--alert) !important;
      }
    }
  }

  .button-container {
    display: flex;
    align-items: center;

    button {
      margin-right: 32px;
    }

    p {
      opacity: 0.6;
    }
  }
`
